// Project Links Configuration
// Update the links here when your projects are deployed

export const projectLinks = {
  // AI/ML Projects
  autonomousTrading: {
    demo: '#', // Add demo link when available
    github: 'https://github.com/samayasri27/multi-agent-trading',
  },
  contentHubStudio: {
    demo: '#', // Add demo link when available
    github: 'https://github.com/samayasri27/content-hub-studio',
  },
  aiInterviewer: {
    demo: '#', // Add demo link when available
    github: '#', // Add GitHub link when available
  },
  personalizedRoadmap: {
    demo: '#', // Add demo link when available
    github: '#', // Add GitHub link when available
  },
  // Existing Projects
  dataCraftAI: {
    demo: 'https://data-science-glimpse.vercel.app',
    github: 'https://github.com/samayasri27/DataCraft-AI-Studio',
  },
  financeManagement: {
    demo: 'https://easy-save-flow-main.vercel.app',
    github: 'https://github.com/samayasri27/Personal-Family-Finance-Tracker',
  },
  industrialData: {
    demo: 'https://data-entry-demo-seven.vercel.app',
    github: 'https://github.com/samayasri27/Industrial-Data-Management-System',
  },
  digitalYouthConnect: {
    demo: 'https://kk-computers-hackathon.vercel.app',
    github: 'https://github.com/samayasri27/24-hack-the-web-hackathon',
  },
  inventoryManagement: {
    demo: 'https://stock-sense-organize-track.vercel.app',
    github: 'https://github.com/samayasri27/inventory-management',
  },
  visualRoadmap: {
    demo: 'https://builder-pulse-realm.vercel.app',
    github: 'https://github.com/samayasri27/Visual-Roadmap-Tracker',
  },
  techFest: {
    demo: 'https://tech-fest-website-three.vercel.app',
    github: 'https://github.com/samayasri27/tech-fest',
  },
};